(ns minorodata.connections.sources.mailchimp
  (:require [minorodata.app.utils :as app.utils]))

(def source
  {:id           "mailchimp"
   :enabled      false
   :name         "Mailchimp (Deprecated)"
   :description  "Marketing automation platform and email marketing service."
   :image-source "mailchimp-2.png"
   :tags         ["marketing"]

   :preview-formatter (fn [] "")

   :form
   {:format-for-api
              (fn [data]
                  (let [{:keys [name description api-token]} data]
                       {:source-type "mailchimp"
                        :name        name
                        :description description

                        :source
                                     {:credentials         {:api-token  api-token}}}))

    :format-for-inputs
              (fn [data]
                  (let [{:keys [source name description]} data
                        {:keys [credentials]} source]
                       (merge
                         (select-keys credentials [:api-token])
                         {:name              name
                          :description       description})))

    ;; TODO:
    ;; Replace :format-for-api and :format-for-fields with a single :mapping, like so
    ;; {:block-type :input
    ;;  :name       :some-name
    ;;  :mapping    [:credentials :some_name]}
    ;; Also, think of having `:input-type :hidden` blocks as placeholders
    ;; for static fields in the final configuration.

    :validate (constantly nil)

    :id :mailchimp-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :input
              :label      "Access Token"
              :required   true
              :name       :api-token
              :type       :password
              :value      ""}

             {:block-type :submit
              :content    "SAVE"}]}


   :extract-form
   {:format-for-api
    (fn [{:keys [name description status action destination-table report list-id]}]
      {:name          name
       :description   description
       :status        status
       :output-tables [destination-table]

       :config
       {:extracts [{:report            report
                    :list-id           list-id
                    :destination-table destination-table
                    :action            action}]}})

    :format-for-inputs
    (fn [data]
      (let [{:extract/keys [name description status config]} data

            extract (get-in config [:extracts 0])]
        (merge
         (select-keys extract [:report :action :list-id :destination-table])
         (app.utils/keep-non-nil-keys
          {:name          name
           :description   description
           :status        status}))))

    :validate (constantly nil)

    :id :mailchimp-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :subtitle
              :content    "Extract Configuration"}

             {:block-type :select
              :label      "Report type"
              :name       :report
              :options    [{:name "Lists"          :value "lists"}
                           {:name "List Info"      :value "list-info"}
                           {:name "Lists Activity" :value "lists-activity"}]
              :required   true
              :value      "lists"}

             {:block-type :input
              :label      "List ID"
              :name       :list-id
              :conditions [[:eq [:report :value] "list-info"]
                           [:eq [:report :value] "lists-activity"]]}

             {:block-type :subtitle
              :content    "Data loading options"}

             {:block-type :select
              :label      "Load method"
              :name       :action
              :options    [{:name "Drop, Create, Load" :value "replace"}
                           {:name "Truncate, Load"     :value "reload"}
                           {:name "Append"             :value "append"}]
              :required   true
              :value      "replace"}

             {:content "Drop table, Create table, load entire table (selected columns)"
              :conditions [[:eq [:action :value] "replace"]]}

             {:content "Truncate table, Load entire table (selected columns)"
              :conditions [[:eq [:action :value] "reload"]]}

             {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
              :conditions [[:eq [:action :value] "append"]]}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})


